export const STRIPE_KEY = 'pk_live_51Ib1dTJfRh4sLA5QbaPMCvB9RbvkzOrH5tdDVCcjVxU7UrCRGAsAYbOJmImEnK78CSRtcR9uRXDWiKS50W7OA1WS00oNPBilC1' /*'pk_test_51J8jB7CtH4u6oWzeXKF9Au7Dopc3Rv9HyZ90a6oHxcDr8mUibbo9zVJmrx9htbrXSdiAPShIawiCRkpUFSZBiyMP0068ECJoOJ'*/;
export const STRIPE_KEY_TEST = 'pk_test_51Ib1dTJfRh4sLA5Qio0tSjwl6mWnyxhm0f2MgswLwsv8UYxzhUlEIbaJtXs8x8nKzzHerWdl07yEq3cP1DH2item00AzAh5Pw6';
// export const STRIPE_KEY = 'pk_test_51JaEZ0DIRisX3QShobGAOfu35zGmZXQfZxCxOFL4e2iqcR9u3Et7XaVWvJmAbD0PMayPZ23IUBnfMng573TIWgZm00s17QlxZ5';
export const API_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:3124' : 'https://kidsmode.net';

export const getSubs = async (customer, test = false) => {
    if (customer) {
        const subs = await fetch(`${API_HOST}/api/subscriptions?customerId=${customer.id}${test ? '&test=1' : ''}`, {}).then(r => r.json());
        return subs.subscriptions ? subs.subscriptions.data : [];
    }
}
